var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      attrs: {
        title: _vm.formData.id ? "修改激活码" : "添加激活码",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.rewriteClearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            rules: _vm.rules,
            model: _vm.formData,
            "label-width": "110px",
            "label-position": "left"
          }
        },
        [
          !_vm.formData.id
            ? [
                _c(
                  "el-form-item",
                  {
                    staticClass: "lodingItem",
                    attrs: { prop: "length", label: "礼包码长度" }
                  },
                  [
                    _c("el-input", {
                      staticClass: "flex-1",
                      attrs: {
                        autocomplete: "off",
                        placeholder: "最小16,最大64位"
                      },
                      model: {
                        value: _vm.formData.length,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "length", $$v)
                        },
                        expression: "formData.length"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "lodingItem",
                    attrs: { prop: "quantity", label: "数量" }
                  },
                  [
                    _c("el-input", {
                      staticClass: "flex-1",
                      attrs: { autocomplete: "off", placeholder: "请输入" },
                      model: {
                        value: _vm.formData.quantity,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "quantity", $$v)
                        },
                        expression: "formData.quantity"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "level_id", label: "礼包码等级" }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择"
                  },
                  model: {
                    value: _vm.formData.level_id,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "level_id", $$v)
                    },
                    expression: "formData.level_id"
                  }
                },
                _vm._l(_vm.codeList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "end_period_time", label: "生效到期时间" }
            },
            [
              _c("el-date-picker", {
                attrs: {
                  "popper-class": "no-atTheMoment",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  type: "datetime",
                  placeholder: "日期"
                },
                model: {
                  value: _vm.formData.end_period_time,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "end_period_time", $$v)
                  },
                  expression: "formData.end_period_time"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "expire_time", label: "过期时间" }
            },
            [
              _c("el-date-picker", {
                attrs: {
                  "popper-class": "no-atTheMoment",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  type: "datetime",
                  placeholder: "日期"
                },
                model: {
                  value: _vm.formData.expire_time,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "expire_time", $$v)
                  },
                  expression: "formData.expire_time"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "card_number", label: "卡号" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: { autocomplete: "off", placeholder: "请输入卡号" },
                model: {
                  value: _vm.formData.card_number,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "card_number", $$v)
                  },
                  expression: "formData.card_number"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "server_id", label: "服务器" }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择"
                  },
                  model: {
                    value: _vm.formData.server_id,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "server_id", $$v)
                    },
                    expression: "formData.server_id"
                  }
                },
                _vm._l(_vm.serverList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit()
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }